module.exports = __webpack_public_path__ + "img/visa.cd8e0284.jpg";